const login = {
  logoFlavor: "Sign in to your space",
  forgottenPassword: "Forgotten password?",
}

export default login;
